// extracted by mini-css-extract-plugin
export var askAiIcon = "_qt-9";
export var container = "_qt-0";
export var groupSeparator = "_qt-a";
export var highlight = "_qt-4";
export var resultIcon = "_qt-5";
export var resultItem = "_qt-7";
export var resultSubtitle = "_qt-3";
export var resultTitle = "_qt-2";
export var resultsList = "_qt-1";
export var searchGroup = "_qt-6";
export var selected = "_qt-8";